module.exports = __webpack_public_path__ + "assets/d57831f5647be2083730fc876483d74e.mp3";